import { render, staticRenderFns } from "./sitemap-primary.vue?vue&type=template&id=10e60a19"
import script from "./sitemap-primary.vue?vue&type=script&lang=js"
export * from "./sitemap-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports